$(document).ready(function () {
});
function callApexChart(data){
  console.log(data)
  var chart = new ApexCharts(document.querySelector("#chart"), data);
  chart.render();
}
function hideVerifyPopup() {
  $(".close").trigger('click');
}

function initTinymce() {
  tinymce.init({
    selector: 'textarea#tiny',
    height: 300,
    menubar: false,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
      'insertdatetime', 'media', 'table', 'code', 'wordcount'
    ],
    toolbar: 'undo redo | blocks | bold italic | ' +
      'alignleft aligncenter alignright alignjustify | ' +
      'bullist numlist outdent indent | removeformat '
  });
}
